(function() { window.GUID_e439b3d4_5dc8_4362_924a_a16617798c12 = { getGuid: function() { return "e439b3d4-5dc8-4362-924a-a16617798c12"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class EventPin extends Controls.ControlBase {
            OnDispose() {
                this.$Control.off("checkbox-valuechanged");
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: ".ExcludeEvent",
                    callback: (control, params) => {
                        me.updateExcludeEvent(control, "ExcludeEvent");
                    }
                });
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: ".ExcludeAwards",
                    callback: (control, params) => {
                        me.updateExcludeEvent(control, "ExcludeAwards");
                    }
                });
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: ".ExcludeFlowBlocks",
                    callback: (control, params) => {
                        me.updateExcludeEvent(control, "ExcludeFlowBlocks");
                    }
                });
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: ".ExcludeSchedules",
                    callback: (control, params) => {
                        me.updateExcludeEvent(control, "ExcludeSchedules");
                    }
                });
                CS.Controls.CheckBox.Events.CheckboxValueChanged({
                    selector: ".ExcludeStats",
                    callback: (control, params) => {
                        me.updateExcludeEvent(control, "ExcludeStats");
                    }
                });
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnControlInstantiated() {
                let me = this;
                me.$scrollablePart = me.$Control.find('.scrollable-part');
            }
            updateExcludeEvent(checkbox, valueToUpdate) {
                let checkedOrNot = checkbox.GetValue() === "false"; //on marche a l'envers, c'Est une table d'exclusion
                let tableParent = checkbox.$Control.closest('.sportevent');
                let me = this;
                let data = {
                    value: checkedOrNot,
                    valueToUpdate: valueToUpdate,
                    sportEventId: tableParent.data("sporteventid")
                };
                //si on desactive event, on coche le reste
                if (valueToUpdate === "ExcludeEvent") {
                    let checkBoxes = tableParent.find('.ckbexclude');
                    checkBoxes.each(function () {
                        if (checkedOrNot === true) {
                            $(this).addClass('checkdisabled');
                        }
                        else {
                            $(this).removeClass('checkdisabled');
                        }
                    });
                }
                CS.Ajax.Post(CS.Url.CSUrl("updateuserentitybaseexclusion"), data, function (response) {
                });
            }
        }
        Controls.EventPin = EventPin;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-pin.js.map
